import {
  CallTransferCreateModel,
  CallTransferRecordModel,
  CallTransferUpdateModel,
} from "./callTransfer";
import {
  CustomActionCreateModel,
  CustomActionRecordModel,
  CustomActionUpdateModel,
} from "./customAction";
import {
  CustomEvalActionRecordModel,
  CustomEvalActionCreateModel,
  CustomEvalActionUpdateModel,
} from "./customEvaluation";
import {
  InformationExtractorCreateModel,
  InformationExtractorRecordModel,
  InformationExtractorUpdateModel,
} from "./informationExtractor";
import {IVRCreateModel, IVRRecordModel, IVRUpdateModel} from "./ivr";
import {
  RealTimeBookingCreateModel,
  RealTimeBookingRecordModel,
  RealTimeBookingUpdateModel,
} from "./realTimeBooking";
import {
  SendSmsCreateModel,
  SendSmsRecordModel,
  SendSmsUpdateModel,
} from "./sendSms";

import {ActionTypeParameter} from "@/api/services";

export const ActionTypeModel = {
  SMS: ActionTypeParameter.sms,
  TRANSFER: ActionTypeParameter.transfer,
  BOOKING: ActionTypeParameter.booking,
  INFO: ActionTypeParameter.info,
  CUSTOM: ActionTypeParameter.custom,
  IVR: ActionTypeParameter.ivr,
  EVAL: ActionTypeParameter.eval,
} as const;

export type ActionTypeModel =
  (typeof ActionTypeModel)[keyof typeof ActionTypeModel];

export type ActionRecordModel =
  | SendSmsRecordModel
  | CallTransferRecordModel
  | InformationExtractorRecordModel
  | RealTimeBookingRecordModel
  | CustomActionRecordModel
  | IVRRecordModel
  | CustomEvalActionRecordModel;

export type ActionCreateModel =
  | SendSmsCreateModel
  | CallTransferCreateModel
  | InformationExtractorCreateModel
  | RealTimeBookingCreateModel
  | CustomActionCreateModel
  | IVRCreateModel
  | CustomEvalActionCreateModel;

export type ActionUpdateModel =
  | SendSmsUpdateModel
  | CallTransferUpdateModel
  | InformationExtractorUpdateModel
  | RealTimeBookingUpdateModel
  | CustomActionUpdateModel
  | IVRUpdateModel
  | CustomEvalActionUpdateModel;
